// Data Mahasiswa
export const dataMahasiswa = [
    {
        mhs_id: 1,
        nim: "20201001",
        nama: "Andi Pratama",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        angkatan: 2020,
        semester: 7,
        jalur: "Reguler",
        kelas: "A",
        status: "Aktif",
        ipk: 3.75,
        sks_total: 120,
        email: "andi.pratama@student.asia.ac.id",
        no_hp: "081234567890",
        alamat: "Jl. Merdeka No. 123, Malang",
        tempat_lahir: "Malang",
        tanggal_lahir: "2002-05-15",
        jenis_kelamin: "L",
        agama: "Islam",
        dosen_wali_id: "DSN001",
        dosen_wali: "Dr. Citra Dewi, S.Kom., M.Cs.",
        foto: null
    },
    {
        mhs_id: 2,
        nim: "20201002",
        nama: "Bella Safitri",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        angkatan: 2020,
        semester: 7,
        jalur: "Reguler",
        kelas: "A",
        status: "Aktif",
        ipk: 3.89,
        sks_total: 120,
        email: "bella.safitri@student.asia.ac.id",
        no_hp: "081234567891",
        alamat: "Jl. Sudirman No. 45, Malang",
        tempat_lahir: "Surabaya",
        tanggal_lahir: "2002-08-20",
        jenis_kelamin: "P",
        agama: "Kristen",
        dosen_wali_id: "DSN001",
        dosen_wali: "Dr. Citra Dewi, S.Kom., M.Cs.",
        foto: null
    },
    {
        mhs_id: 3,
        nim: "20201003",
        nama: "Cahyo Nugroho",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        angkatan: 2020,
        semester: 7,
        jalur: "Reguler",
        kelas: "B",
        status: "Aktif",
        ipk: 3.45,
        sks_total: 118,
        email: "cahyo.nugroho@student.asia.ac.id",
        no_hp: "081234567892",
        alamat: "Jl. Diponegoro No. 67, Malang",
        tempat_lahir: "Jakarta",
        tanggal_lahir: "2001-12-10",
        jenis_kelamin: "L",
        agama: "Islam",
        dosen_wali_id: "DSN003",
        dosen_wali: "Ir. Dedi Hartono, M.Kom.",
        foto: null
    },
    {
        mhs_id: 4,
        nim: "20211001",
        nama: "Dina Amelia",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        angkatan: 2021,
        semester: 5,
        jalur: "Reguler",
        kelas: "A",
        status: "Aktif",
        ipk: 3.67,
        sks_total: 90,
        email: "dina.amelia@student.asia.ac.id",
        no_hp: "081234567893",
        alamat: "Jl. Ahmad Yani No. 89, Malang",
        tempat_lahir: "Malang",
        tanggal_lahir: "2003-03-25",
        jenis_kelamin: "P",
        agama: "Islam",
        dosen_wali_id: "DSN001",
        dosen_wali: "Dr. Citra Dewi, S.Kom., M.Cs.",
        foto: null
    },
    {
        mhs_id: 5,
        nim: "20211002",
        nama: "Eko Saputra",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        angkatan: 2021,
        semester: 5,
        jalur: "Reguler",
        kelas: "A",
        status: "Aktif",
        ipk: 3.12,
        sks_total: 88,
        email: "eko.saputra@student.asia.ac.id",
        no_hp: "081234567894",
        alamat: "Jl. Veteran No. 34, Malang",
        tempat_lahir: "Kediri",
        tanggal_lahir: "2003-07-14",
        jenis_kelamin: "L",
        agama: "Hindu",
        dosen_wali_id: "DSN003",
        dosen_wali: "Ir. Dedi Hartono, M.Kom.",
        foto: null
    },
    {
        mhs_id: 6,
        nim: "20221001",
        nama: "Fitri Handayani",
        prodi_id: 2,
        prodi_nama: "Sistem Informasi",
        fakultas_id: 3,
        angkatan: 2022,
        semester: 3,
        jalur: "Reguler",
        kelas: "A",
        status: "Aktif",
        ipk: 3.55,
        sks_total: 54,
        email: "fitri.handayani@student.asia.ac.id",
        no_hp: "081234567895",
        alamat: "Jl. Kawi No. 12, Malang",
        tempat_lahir: "Blitar",
        tanggal_lahir: "2004-01-30",
        jenis_kelamin: "P",
        agama: "Islam",
        dosen_wali_id: "DSN003",
        dosen_wali: "Ir. Dedi Hartono, M.Kom.",
        foto: null
    },
    {
        mhs_id: 7,
        nim: "20201101",
        nama: "Gilang Ramadhan",
        prodi_id: 3,
        prodi_nama: "Teknik Mesin",
        fakultas_id: 1,
        angkatan: 2020,
        semester: 7,
        jalur: "Reguler",
        kelas: "A",
        status: "Aktif",
        ipk: 3.33,
        sks_total: 116,
        email: "gilang.ramadhan@student.asia.ac.id",
        no_hp: "081234567896",
        alamat: "Jl. Ijen No. 56, Malang",
        tempat_lahir: "Malang",
        tanggal_lahir: "2002-09-05",
        jenis_kelamin: "L",
        agama: "Islam",
        dosen_wali_id: "DSN004",
        dosen_wali: "Dr. Eko Prasetyo, S.T., M.T.",
        foto: null
    },
    {
        mhs_id: 8,
        nim: "20201201",
        nama: "Hana Pertiwi",
        prodi_id: 5,
        prodi_nama: "Manajemen",
        fakultas_id: 2,
        angkatan: 2020,
        semester: 7,
        jalur: "Reguler",
        kelas: "A",
        status: "Aktif",
        ipk: 3.78,
        sks_total: 122,
        email: "hana.pertiwi@student.asia.ac.id",
        no_hp: "081234567897",
        alamat: "Jl. Soekarno Hatta No. 78, Malang",
        tempat_lahir: "Surabaya",
        tanggal_lahir: "2002-04-18",
        jenis_kelamin: "P",
        agama: "Kristen",
        dosen_wali_id: "DSN006",
        dosen_wali: "Dr. Gita Permata, S.E., M.M.",
        foto: null
    },
    {
        mhs_id: 9,
        nim: "20191001",
        nama: "Ivan Kurniawan",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        angkatan: 2019,
        semester: 9,
        jalur: "Reguler",
        kelas: "A",
        status: "Cuti",
        ipk: 2.89,
        sks_total: 100,
        email: "ivan.kurniawan@student.asia.ac.id",
        no_hp: "081234567898",
        alamat: "Jl. Tlogomas No. 90, Malang",
        tempat_lahir: "Pasuruan",
        tanggal_lahir: "2001-06-22",
        jenis_kelamin: "L",
        agama: "Islam",
        dosen_wali_id: "DSN001",
        dosen_wali: "Dr. Citra Dewi, S.Kom., M.Cs.",
        foto: null
    },
    {
        mhs_id: 10,
        nim: "20181001",
        nama: "Julia Maharani",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        angkatan: 2018,
        semester: 12,
        jalur: "Reguler",
        kelas: "A",
        status: "Lulus",
        ipk: 3.92,
        sks_total: 144,
        email: "julia.maharani@student.asia.ac.id",
        no_hp: "081234567899",
        alamat: "Jl. Bandung No. 11, Malang",
        tempat_lahir: "Malang",
        tanggal_lahir: "2000-11-08",
        jenis_kelamin: "P",
        agama: "Islam",
        dosen_wali_id: "DSN001",
        dosen_wali: "Dr. Citra Dewi, S.Kom., M.Cs.",
        foto: null
    }
];

// Dropdown untuk filter
export const dropdownAngkatan = [
    { value: 2024, label: "2024" },
    { value: 2023, label: "2023" },
    { value: 2022, label: "2022" },
    { value: 2021, label: "2021" },
    { value: 2020, label: "2020" },
    { value: 2019, label: "2019" },
    { value: 2018, label: "2018" }
];

export const dropdownStatus = [
    { value: "Aktif", label: "Aktif" },
    { value: "Cuti", label: "Cuti" },
    { value: "Non-Aktif", label: "Non-Aktif" },
    { value: "Lulus", label: "Lulus" },
    { value: "DO", label: "Drop Out" }
];

export const dropdownJalur = [
    { value: "Reguler", label: "Reguler" },
    { value: "Karyawan", label: "Karyawan" },
    { value: "Transfer", label: "Transfer" }
];

export const dropdownKelas = [
    { value: "A", label: "Kelas A" },
    { value: "B", label: "Kelas B" },
    { value: "C", label: "Kelas C" }
];

export default dataMahasiswa;
